import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import ExportDataPage from './exportDataPage'; // Assurez-vous d'importer correctement le composant ExportDataPage
import ParamDataPage from './paramDataPage'; // Assurez-vous d'importer correctement le composant ParamDataPage
import EditDataPage from './editDataPage';
import ArchiveUsersPage from './archiveUsersPage';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const AdminPage = () => {
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const docRef = doc(db, 'users', user.uid); // Remplacez 'users' par le chemin correct vers vos utilisateurs
          const docSnap = await getDoc(docRef);
          if (docSnap.exists() && docSnap.data().isAdmin) {
            // Do nothing
          } else {
            navigate('/'); // Redirigez vers la page d'accueil si l'utilisateur n'est pas admin
          }
        } else {
          navigate('/'); // Redirigez vers la page d'accueil si l'utilisateur n'est pas connecté
        }
      } catch (err) {
        console.error('Erreur lors de la vérification du statut admin :', err);
        navigate('/'); // Redirigez vers la page d'accueil en cas d'erreur
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [navigate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
          <CircularProgress />
        </Box>
      ) : <Box sx={{ width: '100%' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
          variant="fullWidth" // Permet de faire défiler les onglets
          scrollButtons="auto" // Affiche automatiquement les boutons de défilement
        >
          <Tab label={<Typography variant="body2">Exporter les données</Typography>} />
          <Tab label={<Typography variant="body2">Paramétrer les jours</Typography>} />
          <Tab label={<Typography variant="body2">Modifier les données</Typography>} />
          <Tab label={<Typography variant="body2">Archiver utilisateurs</Typography>} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <ExportDataPage /> {/* Affiche la page Admin */}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ParamDataPage /> {/* Affiche la page SelectDays */}
        </TabPanel>
        <TabPanel value={value} index={2}>
          <EditDataPage /> {/* Affiche la page SelectDays */}
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ArchiveUsersPage /> {/* Affiche la page d'archivage des utilisateurs */}
        </TabPanel>
      </Box>}

    </div>

  );
};

export default AdminPage;
